import './App.css';
import  Loader from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useEffect, useState } from 'react';
import Home from './components/home';
function App() {

  const[loading, setLoading]=useState(false);
  useEffect(()=>{
     setTimeout(()=>{
        setLoading(true);
     }, 2000)
  },[])
  return (
    <div className="app">
       {loading ?   
       <>
         <Home />
         </> :   <div className='app__loading'> <Loader
        type="ThreeDots"
        color="#6b1dfc"
        height={100}
        width={100}
        timeout={3000} //3 secs
      />
        </div>
       
        }
    </div>
  );
}

export default App;
